import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { applyTokensFromHash } from "./forge/suite/auth";
import "./index.css";

applyTokensFromHash();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
